import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, useClerk } from "@clerk/react";
import { makeApi, isPreview } from "@/lib/api";

const RoleContext = createContext(null);

export function RoleProvider({ children }) {
  const { isSignedIn, isLoaded, getToken } = useAuth();
  const { signOut } = useClerk();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(null);
  const [preview, setPreview] = useState(isPreview());

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      setIsAdmin(false);
      return;
    }
    setIsAdmin(null);
    makeApi(getToken).get("/me").then(({ data }) => {
      setIsAdmin(data.is_admin);
      if (!data.is_admin && isPreview()) {
        sessionStorage.removeItem("cl_preview");
        setPreview(false);
      }
    }).catch(() => setIsAdmin(false));
  }, [isLoaded, isSignedIn, getToken]);

  const startPreview = async () => {
    await makeApi(getToken).post("/preview/reset");
    sessionStorage.setItem("cl_preview", "1");
    setPreview(true);
    navigate("/");
  };

  const exitPreview = () => {
    sessionStorage.removeItem("cl_preview");
    setPreview(false);
    navigate("/admin");
  };

  const logOut = async () => {
    sessionStorage.removeItem("cl_preview");
    setPreview(false);
    navigate("/home");
    await signOut({ redirectUrl: "/home" });
  };

  const actingAsAdmin = !!isAdmin && !preview;

  return (
    <RoleContext.Provider value={{ isAdmin, preview: !!isAdmin && preview, actingAsAdmin, startPreview, exitPreview, logOut }}>
      {children}
    </RoleContext.Provider>
  );
}

export const useRole = () => useContext(RoleContext);
